export class dispositionCallService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    getCampaignDispositions() {
        const action = "getCampaignDispositions";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            };
            this.SingletonWebSocket.send(message);
        }
    }
    disposeCampaingCall(dispositionId, camId, callID, subId) {
        const action = "disposeCampaingCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const messageDispose = {
                client: "integration",
                DispositionId: dispositionId,
                CamId: camId,
                CallID: callID,
                SubId: subId,
                action: "Disposition",
                subaction: action
            };
            this.SingletonWebSocket.send(messageDispose);
        }
    }
    getACDDispositions() {
        const action = "getACDDispositions";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            };
            this.SingletonWebSocket.send(message);
        }
    }
    disposeACDCall(dispositionId, callID, subId) {
        const action = "disposeACDCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                DispositionId: dispositionId,
                CallID: callID,
                SubId: subId,
                action: "Disposition",
                subaction: "disposeACDCall"
            };
            this.SingletonWebSocket.send(message);
        }
    }
    getDispositions(){
        const action = "getDispositions";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: action
            };
            this.SingletonWebSocket.send(message);
        }
    }
    saveDisposition(callID, dispositionId, subId){
        const action = "saveDisposition";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                CallID: callID,
                DispositionId: dispositionId,
                SubId: subId,
                action: action
            };
            this.SingletonWebSocket.send(message);
        }
    }
}



// WEBPACK FOOTER //
// ./src/Services/dispositionCallService.js